import { gql } from 'apollo-angular'

export const GET_ARTICLE_ID_BY_OLDID = gql`
  query getArticleIdByOldId($oldArticleId: Float!) {
    Articles(select: true, where: { dh_id: { equals: $oldArticleId } }) {
      docs {
        id
      }
    }
  }
`
